import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Clock, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { EbookBanner } from "../components/EbookPromo";

function Card({ p }) {
  return (
    <Link to={`/blog/${p.slug}`} className="group bg-white border border-[#23261C]/10 rounded-2xl overflow-hidden hover:border-[#4F5D1E]/40 transition-all duration-300 block" data-testid={`blog-card-${p.slug}`}>
      <div className="relative h-48 overflow-hidden bg-[#EDEBE1]">
        {p.cover_image && (
          <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <span className="absolute top-3 right-3 text-[10px] font-semibold tracking-widest uppercase bg-[#4F5D1E] text-[#F5F4EF] px-2 py-1 rounded-full" style={{ fontFamily: "Inter, sans-serif" }}>{p.category}</span>
      </div>
      <div className="p-5">
        <h3 className="font-display text-white font-bold text-base leading-snug mb-2 group-hover:text-[#4F5D1E] transition-colors">{p.title}</h3>
        <p className="text-white/50 text-xs leading-relaxed mb-4" style={{ fontFamily: "Inter, sans-serif" }}>{p.excerpt}</p>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-1 text-white/40 text-xs" style={{ fontFamily: "Inter, sans-serif" }}>
            <Clock className="w-3 h-3" /> {p.read_time}
          </span>
          <ArrowRight className="w-4 h-4 text-[#4F5D1E]" />
        </div>
      </div>
    </Link>
  );
}

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/blog/posts").then(({ data }) => setPosts(data.items)).catch(() => setPosts([]));
  }, []);

  return (
    <>
      <Helmet>
        <title>Credit Tips & Guides | Infantry Financial Blog</title>
        <meta name="description" content="Expert credit restoration guides from Infantry Financial — how to read your credit report, remove negative items, and get lender-ready in Texas." />
        <link rel="canonical" href="https://infantry-financial.com/blog" />
      </Helmet>
      <section className="hero-radial py-24 relative z-[2]">
        <div className="container-if">
          <div className="font-mono-label text-[var(--if-gold)] mb-3">Intel & Resources</div>
          <h1 className="font-display text-4xl md:text-6xl mb-4">Tactical Knowledge</h1>
          <p className="text-white/60 text-lg max-w-2xl" style={{ fontFamily: "Inter, sans-serif" }}>
            Prepare yourself for financial approval with expert insights from our team.
          </p>
        </div>
      </section>
      <section className="section bg-white">
        <div className="container-if">
          <EbookBanner />
          {posts === null ? (
            <p className="text-white/50 text-sm" style={{ fontFamily: "Inter, sans-serif" }}>Loading articles…</p>
          ) : posts.length === 0 ? (
            <p className="text-white/50 text-sm" style={{ fontFamily: "Inter, sans-serif" }}>No articles yet — check back soon.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {posts.map((p) => <Card key={p.slug} p={p} />)}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
